export default {"src":"https://images-cdn.curipod.com/d-221d81a5/_next/static/media/wake_county_wcpss.dd36f474.svg","height":67,"width":250};